var _circle, _path, _path2, _g, _g2, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIPort02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "160.667px",
    height: "160.666px",
    viewBox: "0 0 160.667 160.666",
    enableBackground: "new 0 0 160.667 160.666",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#e7ae3b",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 80.947,
    cy: 80.544,
    r: 76.834
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F203E1",
    d: "M120.689,37.607"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F203E1",
    d: "M107.608,43.313"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e7ae3b",
    d: "M70.257,87.18c0,0,1.434-2.723,2.06-8.041c0.903-7.665,8.814-12.3,13.792-6.766 C92.709,79.712,84.303,86.765,70.257,87.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7ae3b",
    d: "M114.835,50.391L91.791,71.312c0,0-2.219,2.259-4.5-0.181L87,70.842c-2.449-2.269-0.202-4.499-0.202-4.499 l20.81-23.031L114.835,50.391z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7ae3b",
    d: "M122.597,43.345c0,0,0.42-0.349,0.491-1.218c0.072-0.87-0.726-2.371-2.773-4.395 c-2.033-2.037-3.539-2.831-4.41-2.755c-0.869,0.076-1.215,0.497-1.215,0.497l-6.147,6.803l-0.037,0.042l7.261,7.228l0,0 L122.597,43.345L122.597,43.345z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e7ae3b",
    d: "M118.622,52.193c0.071,0.045,0.141,0.091,0.21,0.139c2.624,1.775,4.368,4.895,4.368,8.438v37.403 c0,5.512-4.219,9.996-9.403,9.996H48.429c-5.185,0-9.403-4.484-9.403-9.996V60.77c0-5.512,4.219-9.996,9.403-9.996h46.865 l-6.163,6.757H48.429c-1.459,0-2.646,1.453-2.646,3.239v37.403c0,1.785,1.187,3.238,2.646,3.238h65.367 c1.459,0,2.646-1.453,2.646-3.238V60.77c0-1.786-1.187-3.239-2.646-3.239h-0.765L118.622,52.193z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#e7ae3b",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 41.57,
    y1: 118.555,
    x2: 120.988,
    y2: 118.555
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIPort02);
export default __webpack_public_path__ + "static/media/iPort-02.e983ad40d3fc2fbe60193ffafff5b6df.svg";
export { ForwardRef as ReactComponent };